import event from "../../assets/logo/creation-arts-branded-flags-outdoor.png";
import flagpoles from "../../assets/flagpoles/aluminum-manual-internal-halyard-flag-pole-white-powder-coated.svg";
import table from "../../assets/flagpoles/vip-gold-indoor-flagpole-desk-flag.png";
import indoorFlagpoles from "../../assets/flagpoles/flags-1-4.webp";
import uniform from "../../assets/apparels/custom-khaki-work-uniform-uae.jpg";
import lanyards from "../../assets/lanyards/premium-leather-lanyard-id-badge-closeup.png";
import egypt from "../../assets/flags/cairo-flagpole-egypt-new-administrative-capital-aerial.png";
import FenceBanner from "../../assets/banners/fence-mesh-banner-outdoor.svg";
import sticker from "../../assets/stickers/on-building-facade-sticker.png";

import arabMonetaryFund from "../../assets/clients/arab-monetary-fund.png";
import ministryOfForeign from "../../assets/clients/uae-ministry-of-foreign-affairs.png";
import emiratesFoundation from "../../assets/clients/emirates-foundation.png";
import emiratesnationalschool from "../../assets/clients/emirates-national-school.png";
import presidentialCourt from "../../assets/clients/presidential-court-uae.png";
import federalNationalCouncil from "../../assets/clients/federal-national-council-uae.png";
import awqaf from "../../assets/clients/awqaf-islamic-affairs-uae.png";
import uaeCabinet from "../../assets/clients/the-uae-cabinet-logo.png";
import tawazunIndustrialPark from "../../assets/clients/tawazun-industrial-park.png";
import gas from "../../assets/clients/adnoc-gas.png";
import nationalGuard from "../../assets/clients/national-guard1.png";
import puplicProsecution from "../../assets/clients/public-prosecution.png";
import tawazunCouncil from "../../assets/clients/tawazun-council.png";
import adonocSchools from "../../assets/clients/adnoc-schools.png";
import globalMarket from "../../assets/clients/abu-dhabi-global-market.png";
import adnecGroup from "../../assets/clients/adnec-group.png";

export const categoryImageAlts: Record<string, string> = {
  "home:categories:uniforms:title":
    "Custom khaki short-sleeve work uniform with matching trousers for corporate and industrial use",
};

export const homeKeys = {
  hero: {
    seoH1: "home:hero:seoH1",
    badge: "home:hero:badge",
    title: "home:hero:title",
    title2: "home:hero:title2",
    subtitle: "home:hero:subtitle",
    ctaPrimaryLabel: "home:hero:ctaPrimary",
    ctaPrimaryHref: "/contact",
    ctaSecondaryLabel: "home:hero:ctaSecondary",
    ctaSecondaryHref: "/services",
    trust1: "home:hero:trust1",
    trust2: "home:hero:trust2",
  },
  trustedBy: {
    title: "home:sections:trustedByTitle",
    logos: [
      { src: arabMonetaryFund, alt: "Arab Monetary Fund official logo" },
      {
        // Served from /public so the URL is a real file, never an inlined data URI.
        src: "/clients/etihad-arena.png",
        alt: "Etihad Arena Abu Dhabi official logo",
        width: 438,
        height: 219,
      },
      {
        src: ministryOfForeign,
        alt: "UAE Ministry of Foreign Affairs official logo",
      },
      { src: emiratesFoundation, alt: "Emirates Foundation official logo" },
      {
        src: emiratesnationalschool,
        alt: "Emirates National School official logo",
      },
      { src: presidentialCourt, alt: "UAE Presidential Court official logo" },
      {
        src: federalNationalCouncil,
        alt: "Federal National Council of the UAE official logo",
      },
      {
        src: awqaf,
        alt: "General Authority of Islamic Affairs Endowments and Zakat official logo",
      },
      { src: uaeCabinet, alt: "UAE Cabinet official logo" },
      {
        src: tawazunIndustrialPark,
        alt: "Tawazun Industrial Park official logo",
      },
      { src: gas, alt: "ADNOC Gas official logo" },
      { src: nationalGuard, alt: "UAE National Guard official logo" },
      { src: puplicProsecution, alt: "UAE Public Prosecution official logo" },
      { src: tawazunCouncil, alt: "Tawazun Council official logo" },
      {
        src: "/clients/aldar.png",
        alt: "Aldar Properties official logo",
        width: 261,
        height: 261,
      },
      { src: adonocSchools, alt: "ADNOC Schools official logo" },
      { src: adnecGroup, alt: "ADNEC Group Abu Dhabi official logo" },
      { src: globalMarket, alt: "Abu Dhabi Global Market official logo" },
    ],
  },
  stats: [
    { label: "about:stats:years", value: "25+" },
    { label: "World’s Largest Flag Produced", value: "2,604 m²" },
    { label: "Private Clients", value: "500 +" },
  ],
  sections: {
    whyTitle: "home:sections:whyTitle",
    popularTitle: "home:sections:popularTitle",
    howTitle: "home:sections:howTitle",
    finalLead: "home:sections:finalLead",
    finalBtn: "home:sections:finalBtn",
    faqTitle: "home:faq:title",
  },

  features: [
    {
      title: "home:features:premiumMaterials:title",
      text: "home:features:premiumMaterials:text",
    },
    {
      title: "home:features:fastPrecisionPrinting:title",
      text: "home:features:fastPrecisionPrinting:text",
    },
    {
      title: "home:features:anySize:title",
      text: "home:features:anySize:text",
    },
    {
      title: "home:features:worldRecord:title",
      text: "home:features:worldRecord:text",
    },
  ],

  categories: [
    {
      key: "home:categories:indoor:title",
      subtitle: "home:categories:indoor:subtitle",
      descKey: "home:categories:indoor:description",
      image: indoorFlagpoles,
      alt: "Two floor-standing indoor UAE flagpoles with gold and chrome stands and ornate finials",
      to: "/services/flagpoles",
    },
    {
      key: "home:categories:table:title",
      subtitle: "home:categories:table:subtitle",
      descKey: "home:categories:table:description",
      image: table,
      alt: "UAE national desk flag on VIP gold table flagpole stand with ornate finial",
      to: "/services/flagpoles",
    },
    {
      key: "home:categories:outdoor:title",
      subtitle: "home:categories:outdoor:subtitle",
      descKey: "home:categories:outdoor:description",
      image: flagpoles,
      alt: "White powder-coated aluminum outdoor flagpole with manual internal halyard system",
      to: "/services/flagpoles",
    },
    {
      key: "home:categories:sticker:title",
      subtitle: "home:categories:sticker:subtitle",
      descKey: "home:categories:sticker:description",
      image: sticker,
      alt: "Large-scale custom sticker installed on commercial building facade",
      to: "/services/sticker",
    },

    {
      key: "home:categories:giantFlags:title",
      subtitle: "home:categories:giantFlags:subtitle",
      descKey: "home:categories:giantFlags:description",
      image: egypt,
      alt: "Giant national flag on record-scale mega flagpole — aerial view of large-scale flag manufacturing project",
      to: "/services/custom-flags",
    },
    {
      key: "home:categories:corporate:title",
      subtitle: "home:categories:corporate:subtitle",
      descKey: "home:categories:corporate:description",
      image: event,
      alt: "Creation Arts branded outdoor flags displaying company logo and Pure Quality Pure Satisfaction slogan",
      to: "/services/custom-flags",
    },
    {
      key: "home:categories:uniforms:title",
      subtitle: "home:categories:uniforms:subtitle",
      descKey: "home:categories:uniforms:description",
      image: uniform,
      alt: "Custom khaki short-sleeve work uniform with matching trousers for corporate and industrial use",
      to: "/services/apparel",
    },
    {
      key: "home:categories:banners:title",
      subtitle: "home:categories:banners:subtitle",
      descKey: "home:categories:banners:description",
      image: FenceBanner,
      alt: "Outdoor fence mesh banner for construction sites and perimeter branding",
      to: "/services/banners",
    },
    {
      key: "home:categories:lanyard:title",
      subtitle: "home:categories:lanyard:subtitle",
      descKey: "home:categories:lanyard:description",
      image: lanyards,
      alt: "Premium leather and fabric lanyards with metal hardware and ID badge attachments",
      to: "/services/lanyards",
    },
  ],
  process: [
    "home:process:step1",
    "home:process:step2",
    "home:process:step3",
    "home:process:step4",
  ],
  faq: {
    title: "home:faq:title",
    items: [
      { q: "home:faq:items:0:q", a: "home:faq:items:0:a" },
      { q: "home:faq:items:1:q", a: "home:faq:items:1:a" },
      { q: "home:faq:items:2:q", a: "home:faq:items:2:a" },
      { q: "home:faq:items:3:q", a: "home:faq:items:3:a" },
      { q: "home:faq:items:4:q", a: "home:faq:items:4:a" },
    ],
  },
} as const;
